import * as types from "./mutation-types";

const mutations = {
  [types.SET_CURRENT_CUSTOMER](state, { id }) {
    state.current = id;
  },
  [types.ADD_CUSTOMER](state, customer) {
    state.all = Object.assign({}, state.all, { [customer.id]: customer });
  },
  [types.UPDATE_CUSTOMER](state, customer) {
    if (!state.all[customer.id]) {
      mutations[types.ADD_CUSTOMER](state, customer);
      return;
    }

    state.all[customer.id] = Object.assign({}, state.all[customer.id], {
      ...customer,
    });
  },
  [types.SET_CUSTOMERS](state, customers) {
    customers = customers.map(customer => ({ [customer.id]: customer }));
    state.all = Object.assign({}, state.all, ...customers);
  },
  [types.RESET_CUSTOMERS](state) {
    state.all = {};
  },
  [types.RESET_CURRENT_CUSTOMER](state) {
    state.current = null;
  },
  [types.SET_CUSTOMER_LEVELS](state, levels) {
    state.levels = {};

    if (levels) {
      levels.forEach(level => (state.levels[level.id] = level));
    }
  },
};

export default mutations;
